<template>
  <div>
    <e-dialog
      dialog-title="发起申请"
      :center-dialog-visible="launchVisible"
      :popup-width="'960px'"
      :destroy-close="true"
      only-show-cancel
      :modal-append-to-body="true"
      @resetPopupData="launchCancel"
      @submitPopupData="launchSave"
    >
      <!-- 搜索 -->
      <div>
        <e-search
          :data="listQuery"
          :field-list="fieldList"
          :count="7"
          @handleFilter="handleFilter"
          @handleReset="handleReset"
        ></e-search>
      </div>
      <div style="margin-top: 10px">
        <tableList :table-data="tableData" :table-label="tableLabel">
          <template #orgSetting="{ scope }">
            <span>{{ getOrgSetting(scope.row.orgSetting) }}</span>
          </template>
          <template #openEpecPurchase="{ scope }">
            <span>{{ getOpenEpecPurchase(scope.row.openEpecPurchase) }}</span>
          </template>
          <template #corporateCreditGrade="{ scope }">
            <span>{{
              getCorporateCreditGrade(scope.row.corporateCreditGrade)
            }}</span>
          </template>
          <template #handle="{ scope }">
            <eui-btn type="text" @click="handleApply(scope.row)"
              >申请备案</eui-btn
            >
          </template>
        </tableList>
      </div>
    </e-dialog>
    <ApplyDialog
      v-if="applyVisible"
      :apply-visible.sync="applyVisible"
      :apply-form="applyForm"
      @refresh="handleReset"
    />
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list';
import ESearch from '@/modules/projectA/components/common/e-search';
import EDialog from '@/components/common/e-dialog';
import Api from '@/modules/projectA/api/filing';
import ApplyDialog from './applyDialog.vue';

import mixins from './mixins';

export default {
  components: { EDialog, ESearch, TableList, ApplyDialog },
  mixins: [mixins],
  props: {
    launchVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      applyForm: {},
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        filingType: 2,
        resourceCompanyName: '',
      },
      tableData: [],
      fieldList: [
        { label: '企业全称', type: 'input', value: 'resourceCompanyName' },
      ],
      tableLabel: [
        {
          label: '公司名称',
          param: 'resourceCompanyName',
          align: 'center',
          fixed: 'left',
          minWidth: '220',
        },
        {
          label: '备案状态',
          param: 'filingStatusDesc',
          align: 'center',
        },
        {
          label: '备案方',
          param: 'filingCompanyName',
          align: 'center',
          minWidth: '220',
        },
        {
          label: '组织机构配置',
          param: 'inquiryCompanyName',
          align: 'center',
          width: '120',
        },
        {
          label: '组织机构配置',
          param: 'orgSetting',
          align: 'center',
          slot: 'orgSetting',
          width: '150',
        },
        {
          label: '是否开通易专采',
          param: 'openEpecPurchase',
          align: 'center',
          slot: 'openEpecPurchase',
          width: '150',
        },
        {
          label: '法人信用认证等级',
          param: 'corporateCreditGrade',
          align: 'center',
          slot: 'corporateCreditGrade',
          width: '150',
        },
        {
          label: '行业',
          param: 'industry',
          align: 'center',
          width: '200',
        },
        {
          label: '操作',
          align: 'center',
          slot: 'handle',
          fixed: 'right',
        },
      ],
      applyVisible: false,
    };
  },
  mounted() {},
  methods: {
    async handleApply(row) {
      const { resourceId } = row;
      const result = await Api.checkFilingApply({ resourceId });
      if (result.code === '200') {
        this.applyForm = { ...row, ...result.data, filingType: 2 };
        console.log(result.data, this.applyForm, 'this.applyForm ');
        // this.$emit('update:launchVisible', false);
        this.applyVisible = true;
      }
    },
    // 获取数据
    async getList(params) {
      const result = await Api.queryFilingResourcePage(params);
      if (result.code === '200') {
        const { data } = result;
        this.tableData = [...data.records];
      }
    },
    // 查询
    handleFilter(val) {
      this.listQuery = { ...val, pageNum: 1 };
      if (!this.listQuery.resourceCompanyName) {
        return;
      }
      this.getList(this.listQuery);
    },

    // 重置
    handleReset() {
      this.tableData = [];
      this.listQuery.resourceCompanyName = '';
    },

    launchCancel() {
      this.$emit('update:launchVisible', false);
      this.handleReset();
    },
    launchSave() {},
  },
};
</script>
<style lang="scss" scoped></style>
